var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", { staticClass: "unstriped hover boss-table" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "tbody",
      _vm._l(_vm.options, function (option, i) {
        return _c("job-published-option", { key: i, attrs: { option: option } })
      }),
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "boss-table-head-center" }, [
          _vm._v("\n        フォーマット\n      "),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "boss-table-head-center" }, [
          _vm._v("\n        記事名\n      "),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "boss-table-head-center" }, [
          _vm._v("\n        掲載期間\n      "),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "boss-table-head-center" }, [
          _vm._v("\n        プレビュー\n      "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }